// Thin wrapper over the generated catalog. The DATA is generated from the
// canonical config/ai-models.json by scripts/gen-client-aimodels.js (run via
// the client prebuild/prestart hooks). Do NOT hand-edit aiModels.generated.json;
// edit config/ai-models.json and regenerate.

import CONFIG from './aiModels.generated.json';

export const AI_MODELS = Object.values(CONFIG.models).map((m) => ({
  id: m.id,
  label: m.label,
  vendor: m.vendor,
  logoComponent: m.logoComponent,
  capabilities: m.capabilities,
}));

export const MODEL_BY_ID = Object.fromEntries(AI_MODELS.map((m) => [m.id, m]));

export const SURFACE_REQUIREMENTS = Object.fromEntries(
  Object.entries(CONFIG.surfaces).map(([s, def]) => [s, def.requirements || {}]),
);

// Keys in a surface's requirements that are NOT capability checks.
const NON_CAPABILITY_KEYS = new Set(['lockedTo', 'defaultModel']);

export function isCompatible(model, requirements) {
  const reqs = requirements || {};
  if (reqs.lockedTo && model.id !== reqs.lockedTo) return false;
  return Object.entries(reqs).every(([cap, need]) => {
    if (NON_CAPABILITY_KEYS.has(cap)) return true;
    return !need || model.capabilities[cap];
  });
}

export function modelsForSurface(surface) {
  const req = SURFACE_REQUIREMENTS[surface] || {};
  return AI_MODELS.map((m) => ({ ...m, compatible: isCompatible(m, req) }));
}

export function isKnownModel(id) {
  return Object.hasOwn(MODEL_BY_ID, id);
}
